import { get } from 'lodash-es';

import { RoleEnum } from '@enum/role.enum';
import { useCurrentApplication } from '@hook/application/use-current-application.hook';

export const useMemberRole = () => {
  const application = useCurrentApplication();

  const role = get(application, ['current', 'role']);

  const isOwner = role === RoleEnum.Owner;
  const isAdmin = role === RoleEnum.Admin;
  const isDeveloper = role === RoleEnum.Developer;
  const isViewer = role === RoleEnum.User;

  return {
    isOwner,
    isAdmin,
    isDeveloper,
    isViewer,
  };
};
